"use client";;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();

import type {
	PayloadAdminBarProps,
	PayloadMeUser,
} from "@payloadcms/admin-bar";
import { PayloadAdminBar } from "@payloadcms/admin-bar";
import { usePathname, useRouter, useSelectedLayoutSegments } from "next/navigation";
import React, { useEffect, useState } from "react";
import { cn } from "@/utilities/ui";

import "./index.scss";

import { getClientSideURL } from "@/utilities/getURL";

const baseClass = "admin-bar";

const collectionLabels: Record<string, { plural: string; singular: string }> = {
	pages: {
		plural: "Pages",
		singular: "Page",
	},
	insights: {
		plural: "Insights",
		singular: "Insight",
	},
	cases: {
		plural: "Cases",
		singular: "Case",
	},
	jobs: {
		plural: "Jobs",
		singular: "Job",
	},
};

export const AdminBar: React.FC<{
	adminBarProps?: PayloadAdminBarProps;
}> = (props) => {
	const { adminBarProps } = props || {};
	const segments = useSelectedLayoutSegments();
	const [show, setShow] = useState(false);
	const [docId, setDocId] = useState<string>("");

	// Route shapes:
	//   /[locale]                       → segments=[]            → pages/home
	//   /[locale]/foo                   → segments=["foo"]       → pages/foo
	//   /[locale]/cases                 → segments=["cases"]     → pages/cases
	//   /[locale]/cases/bar             → segments=["cases","bar"] → cases/bar
	// A collection lookup only happens when there's a doc slug after the
	// collection name; otherwise the segment is a Page slug that happens
	// to share a name with a collection (e.g. "cases", "jobs").
	const isCollectionRoute =
		segments?.length >= 2 && Boolean(collectionLabels[segments[0]]);
	const collection = isCollectionRoute ? segments[0] : "pages";
	const slug = isCollectionRoute ? segments[1] : (segments?.[0] ?? "home");

	const router = useRouter();
	const pathname = usePathname();
	const locale = pathname.split("/").filter(Boolean)[0] || "nl";

	const onAuthChange = React.useCallback((user: PayloadMeUser) => {
		setShow(Boolean(user?.id));
	}, []);

	useEffect(() => {
		if (!show || !slug) {
			setDocId("");
			return;
		}
		const cmsURL = getClientSideURL();
		fetch(
			`${cmsURL}/api/${collection}?where[slug][equals]=${slug}&locale=${locale}&limit=1&depth=0&select[id]=true`,
		)
			.then((res) => res.json())
			.then((data) => {
				const id = data?.docs?.[0]?.id;
				if (id) setDocId(String(id));
			})
			.catch(() => setDocId(""));
	}, [show, collection, slug, locale]);

	return (
		<div
			className={cn(baseClass, {
				block: show,
				hidden: !show,
			})}
		>
			<div className="container">
				<PayloadAdminBar
					{...adminBarProps}
					className="py-2 text-white"
					classNames={{
						controls: "font-medium text-white",
						logo: "text-white",
						user: "text-white",
					}}
					cmsURL={getClientSideURL()}
					collectionSlug={collection}
					id={docId || undefined}
					collectionLabels={{
						plural: collectionLabels[collection]?.plural || "Pages",
						singular: collectionLabels[collection]?.singular || "Page",
					}}
					onAuthChange={onAuthChange}
					onPreviewExit={() => {
						fetch("/next/exit-preview").then(() => {
							router.push("/");
							router.refresh();
						});
					}}
					style={{
						backgroundColor: "transparent",
						padding: 0,
						position: "relative",
						zIndex: "unset",
					}}
				/>
			</div>
		</div>
	);
};
